import React, { useState, useEffect, setState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import TableFields from "../../../constants/FeatureConfig/TableFields.json";
import FilterButton from "../Components/FilterButton";
import styled from "styled-components";
import Button from "sushiweb/Button";
import variables from "../../../constants/assets/variables";
import ConfigTable from "../Components/ConfigTable";
import FeatureConfigFormModal from "../FeatureConfigFormModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureConfigActions from "../../../store/actions/FeatureConfig";
import AutoComplete from "../Components/AutoComplete";
import { getFormattedISODateString, getFormattedFileSize, getPath } from "../../../utils";
import { useHistory } from "react-router-dom";

const AddButtonContainer = styled.div`
  &:not(:last-child) {
    margin-right: 10px;
  }
  .sushi-btn span {
    border-color: black !important;
  }

  .sushi-btn {
    position: relative;
    height: 44px;
    width: 80% !important;
    &:after {
      width: ${({ isFilterPresent }) => (isFilterPresent ? "24px" : "0px")};
      height: ${({ isFilterPresent }) => (isFilterPresent ? "24px" : "0px")};
      border-radius: 50%;
      position: absolute;
      background-color: ${variables.primaryColor};
      content: attr(data-tag);
      color: #fff;
      text-align: center;
      padding-top: 2px;
      font-weight: 600;
      right: -10px;
      top: -10px;
    }
  }
`;

const ListView = (props) => {
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [pageTokens, setPageTokens] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const filterFields = ["entity", "entityId"];

  const history = useHistory();
  const handleClose = () => {
    setModalState(false);
  };

  const handlePagination = (page, data) => {
    const pageTokens = { ...pageTokens };
    pageTokens[page] = data;
    setPageTokens(pageTokens);
  };

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  useEffect(() => {
    refreshConfigs();
  }, []);

  const getFieldValue = (list, key, idx, rowData) => {
    switch (key) {
      case "actions":
        return (
          <span
            onClick={() => {
              const queryString = `namespace=${selectedNamespace}&key=${rowData.key}&entity=${rowData.entity}&entityId=${rowData.entityId}`;
              const targetRoute = `/feature-config/details?${queryString}`;
              history.push(targetRoute);
            }}
            style={{ color: "black" }}
            className={"edit-options cursor-pointer"}
          >
            View / Edit
          </span>
        );
      case "value":
        const value = getPath(list, key, "NA");
        if (typeof value == "object") {
          return JSON.stringify(value);
        }
        return `${value}`;
      case "fileSize":
        return getFormattedFileSize(list[key]);
      case "updatedAt":
      case "createdAt":
        return getFormattedISODateString(list[key]);  
      case "stable":
        return list[key] ? String(list[key]) : "false"   
      default:
        return getPath(list, key, "NA");
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
      case "Edit":
        return (
          <FeatureConfigFormModal
            activeId={activeId}
            modalState={modalState}
            handlePagination={handlePagination}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handleClose={handleClose}
            selectedNamespace={selectedNamespace}
            selectedKey={selectedKey}
          />
        );
      case "Filter":
        return (
          <FeatureConfigFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
            setPageTokens={setPageTokens}
            filterFields={filterFields}
            currentPage={currentPage}
            handlePagination={handlePagination}
            setCurrentPage={setCurrentPage}
            selectedNamespace={selectedNamespace}
            selectedKey={selectedKey}
            selectedEntity={getPath(
              props,
              "activeHierarchyFiltersConfig.entity",
              null
            )}
            selectedEntityId={getPath(
              props,
              "activeHierarchyFiltersConfig.entityId",
              null
            )}
            selectedCityId={getPath(props, "activeCityId", "")}
          />
        );
      default:
        return;
    }
  };

  const [selectedNamespace, setSelectedNamespace] = useState(props.namespace);
  const [selectedKey, setSelectedKey] = useState(props.selectedKey);

  const refreshConfigs = () => {
    const page = 1;
    let hierarchy = null
    const entity = getPath(props, "activeHierarchyFiltersConfig.entity", null);
    if(entity != null || selectedKey == ""){
      hierarchy =  {
        entity: getPath(props, "activeHierarchyFiltersConfig.entity", ""),
        entityId: getPath(props, "activeHierarchyFiltersConfig.entityId", ""),
      }
    }
    const payload = {
      filters: {
        key: selectedKey,
        hierarchy: hierarchy,
      },
      namespace: selectedNamespace,
      pagination: {
        limit: 20,
      },
      page,
    };
    if (payload.filters.key || payload.filters.hierarchy != undefined) {
      props.filterKeyConfigs(payload).then((res) => {
        if (res) {
          handlePagination(page, { pageToken: res.pagination?.pageToken });
          handlePagination(page, { pageToken: res.pagination?.nextPageToken });
          setCurrentPage(page);
          handleClose();
        }
      });
    }
  };

  const handleChange = (field, val) => {
    let key = selectedKey;
    let namespace = selectedNamespace;
    if (field === "key") {
      key = val;
      setSelectedKey(val);
    } else if (field === "namespace") {
      namespace = val;
      setSelectedNamespace(val);
    }

    let queryString = `namespace=${namespace}`;
    queryString += `&key=${key}`;

    
    const entity = getPath(
      props,
      "activeHierarchyFiltersConfig.entity",
      null
    )

    if(entity != null || key == ""){
      queryString += `&entity=${entity || ""}`;
      queryString += `&entityId=${getPath(
        props,
        "activeHierarchyFiltersConfig.entityId",
        ""
      )}`;

    }
    
    const targetRoute = `/feature-config/list?${queryString}`;
    history.push(targetRoute);
  };

  return (
    <>
      <Paper
        sx={{
          margin: "auto",
          width: "80%",
          boxShadow: "none",
          justifyContent: "flex-end",
          background: "none",
        }}
      >
        <Grid container sx={{ background: "none" }}>
          <Grid item md={2} xs={6} sx={{ p: 1 }}>
            <AutoComplete
              id="KeyListDropDown"
              className="sushi-dropdown"
              required
              getActiveList={props.getNamespaces}
              labelKey="namespace"
              value={selectedNamespace}
              keyName="namespace"
              resKey="namespaces"
              label="Namespace"
              handleChange={handleChange}
              remoteSearchApplicable={true}
              keyTypeToSet="namespace"
              remoteSearchKey="namespace"
            />
          </Grid>
          <Grid item md={2} xs={6} sx={{ p: 1 }}>
            <AutoComplete
              id="KeyListDropDown"
              className="sushi-dropdown"
              getActiveList={props.getKeys}
              value={selectedKey}
              resKey="keys"
              label="Key"
              isStringList={true}
              keyName="key"
              activeListExtraParam={selectedNamespace}
              remoteSearchApplicable={true}
              handleChange={handleChange}
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
            sx={{
              p: 1,
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          ></Grid>
          <Grid
            item
            md={2}
            xs={6}
            sx={{ p: 1, justifyContent: "flex-end", marginRight: 0 }}
          >
            <FilterButton
              handleClick={() => handleClick("Filter", null)}
              activeFilters={props.activeHierarchyFiltersConfig}
            />
          </Grid>
          <Grid
            item
            md={2}
            xs={6}
            sx={{ p: 1, justifyContent: "flex-start", marginLeft: 0 }}
          >
            <AddButtonContainer>
              <Button
                btnColor="coal"
                appearance="solid"
                style={{ width: "100%" }}
                className={"sushi-btn ml-20"}
                onClick={() => handleClick("Add", null)}
              >
                New Config
              </Button>
            </AddButtonContainer>
          </Grid>
        </Grid>
      </Paper>
      <ConfigTable
        list={props.configs}
        getFieldValue={getFieldValue}
        fields={TableFields}
        prevPage={props.prevPage}
        nextPage={props.nextPage}
        selectedNamespace={selectedNamespace}
        selectedKey={selectedKey}
        key={selectedKey}
        pageTokens={pageTokens}
        setPageTokens={setPageTokens}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        handlePagination={handlePagination}
        wrapContents={true}
      />
      {modalState && getModal()}
    </>
  );
};

function mapStateToProps(state) {
  const { FeatureConfig } = state;
  return {
    namespaces: FeatureConfig.namespaces,
    keys: FeatureConfig.keys,
    configs: FeatureConfig.configs,
    prevPage: FeatureConfig.prevPage,
    nextPage: FeatureConfig.nextPage,
    currentNamespace: FeatureConfig.currentNamespace,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNamespaces: bindActionCreators(
      FeatureConfigActions.getNamespaces,
      dispatch
    ),
    getKeys: bindActionCreators(FeatureConfigActions.getKeys, dispatch),
    filterKeyConfigs: bindActionCreators(
      FeatureConfigActions.filterKeyConfigs,
      dispatch
    ),
    setCurrentNamespace: bindActionCreators(
      FeatureConfigActions.setCurrentNamespace,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListView);
